import * as actionTypes from '../actions/actionTypes.js';
import { BETLION_DEPOSIT_CHANNELS, TAX_TYPE_DEPOSIT } from '@/constants/paymentProvider';

/**
 * @deprecated
 * @param data
 */
export function initiateBridgerPayDeposit(data: any): any {
  return {
    type: actionTypes.deposit.INITIATE_BRIDGER_PAY_DEPOSIT,
    data,
  };
}

/**
 * @deprecated
 * @param data
 */
export function bridgerPayInitiatedSuccess(data: any): any {
  return {
    type: actionTypes.deposit.INITIATE_BRIDGER_PAY_DEPOSIT_SUCCESS,
    data,
  };
}

/**
 * @deprecated
 */
export function bridgerPayInitiatedFailed(): any {
  return {
    type: actionTypes.deposit.INITIATE_BRIDGER_PAY_DEPOSIT_FAILED,
  };
}

/**
 * @deprecated
 * @param data
 */
export function bridgerPayDepositResponse(data: any): any {
  return {
    type: actionTypes.deposit.BRIDGER_PAY_DEPOSIT_RESPONSE,
    data,
  };
}

/**
 * @deprecated
 * @param data
 */
export function initiateBridgerApplePayDeposit(data: any): any {
  return {
    type: actionTypes.deposit.INITIATE_BRIDGER_APPLE_PAY_DEPOSIT,
    data,
  };
}

/**
 * @deprecated
 * @param data
 */
export function updateBridgerApplePayDeposit(data: any): any {
  return {
    type: actionTypes.deposit.UPDATE_BRIDGER_APPLE_PAY_DEPOSIT,
    data,
  };
}
/**
 * @deprecated
 * @param data
 */
export function bridgerApplePayInitiatedSuccess(data: any): any {
  return {
    type: actionTypes.deposit.INITIATE_BRIDGER_APPLE_PAY_DEPOSIT_SUCCESS,
    data,
  };
}
/**
 * @deprecated
 */
export function bridgerApplePayInitiatedFailed(data:any): any {
  return {
    type: actionTypes.deposit.INITIATE_BRIDGER_APPLE_PAY_DEPOSIT_FAILED,
    data,
  };
}
/**
 * @deprecated
 * @param data
 */
export function bridgerApplePayDepositResponse(data: any): any {
  return {
    type: actionTypes.deposit.BRIDGER_APPLE_PAY_DEPOSIT_RESPONSE,
    data,
  };
}


/**
 * @deprecated
 * @param data
 */
export function initiateBridgerCustomWalletDeposit(data: any): any {
  return {
    type: actionTypes.deposit.INITIATE_BRIDGER_CUSTOM_WALLET_DEPOSIT,
    data,
  };
}

/**
 * @deprecated
 * @param data
 */
export function updateBridgerCustomWalletDeposit(data: any): any {
  return {
    type: actionTypes.deposit.UPDATE_BRIDGER_CUSTOM_WALLET_DEPOSIT,
    data,
  };
}
/**
 * @deprecated
 * @param data
 */
export function bridgerCustomWalletInitiatedSuccess(data: any): any {
  return {
    type: actionTypes.deposit.INITIATE_BRIDGER_CUSTOM_WALLET_DEPOSIT_SUCCESS,
    data,
  };
}
/**
 * @deprecated
 */
export function bridgerCustomWalletInitiatedFailed(data:any): any {
  return {
    type: actionTypes.deposit.INITIATE_BRIDGER_CUSTOM_WALLET_DEPOSIT_FAILED,
    data,
  };
}
/**
 * @deprecated
 * @param data
 */
export function bridgerCustomWalletDepositResponse(data: any): any {
  return {
    type: actionTypes.deposit.BRIDGER_CUSTOM_WALLET_DEPOSIT_RESPONSE,
    data,
  };
}

/**
 * @deprecated
 * @param data
 */
export function finishBridgerPayDeposit(data: any): any {
  return {
    type: actionTypes.deposit.FINISH_BRIDGER_PAY_DEPOSIT,
    data,
  };
}
/**
 * @deprecated
 * @param data
 */
export const oktoCreatePaymentCode = (paymentDetails: any) => {
  return {
    type: actionTypes.deposit.OKTO_CREATE_PAYMENT_CODE,
    paymentDetails,
  };
};

/**
 * @deprecated
 * @param data
 */
export const oktoReceivedPaymentCode = (data: any) => {
  return {
    type: actionTypes.deposit.OKTO_RECEIVED_PAYMENT_CODE,
    data: data,
  };
};
/**
 * @deprecated
 */
export const oktoGetCustomer = () => {
  return {
    type: actionTypes.deposit.OKTO_GET_CUSTOMER,
  };
};
/**
 * @deprecated
 * @param data
 */
export const oktoReceivedCustomer = (data: any) => {
  return {
    type: actionTypes.deposit.OKTO_RECEIVED_CUSTOMER,
    data: data,
  };
};
/**
 * @deprecated
 */
export const oktoReset = () => {
  return {
    type: actionTypes.deposit.OKTO_RESET,
  };
};
/**
 * @deprecated
 * @param paymentDetails
 */
export const aircashGetPaymentLink = (paymentDetails: any) => {
  return {
    type: actionTypes.deposit.AIRCASH_REQUEST_PAYMENT_LINK,
    paymentDetails,
  };
};
/**
 * @deprecated
 * @param data
 */
export const receivedAircashPaymentLink = (data: any) => {
  return {
    type: actionTypes.deposit.AIRCASH_RECEIVED_PAYMENT_LINK,
    response: data,
  };
};
/**
 * @deprecated
 */
export const fetchPlayerPaymentMethods = () => {
  return {
    type: actionTypes.deposit.FETCH_PLAYER_PAYMENT_METHODS,
  };
};
/**
 * @deprecated
 * @param data
 */
export const receivedPlayerPaymentMethods = (data: any) => {
  return {
    type: actionTypes.deposit.RECEIVED_PLAYER_PAYMENT_METHODS,
    data,
  };
};
/**
 * @deprecated
 */
export const resetDeposit = () => {
  return {
    type: actionTypes.deposit.RESET,
  };
};
/**
 * @param data
 */
export const initiateBetLionDeposit = (data: {
  amount: any;
  bonusId: any;
  channelId: string;
  rewardId: any;
  alternateMsisdn?: string | null;
}) => {
  return {
    type: actionTypes.deposit.INITIATE_BETLION_DEPOSIT,
    data,
  };
};
/**
 * @param data
 */
export const betLionDepositInitiatedSuccess = (data: any) => {
  return {
    type: actionTypes.deposit.INITIATE_BETLION_DEPOSIT_SUCCESS,
    data,
  };
};
/**
 * @deprecated
 */
export const betLionDepositInitiatedFailed = () => {
  return {
    type: actionTypes.deposit.INITIATE_BETLION_DEPOSIT_FAILED,
  };
};
/**
 * @deprecated
 */
export const betLionDepositInitiatedPending = () => {
  return {
    type: actionTypes.deposit.INITIATE_BETLION_DEPOSIT_PENDING,
  };
};
/**
 * @deprecated
 * @param channelsType
 */
export const betLionGetChannels = (channelsType: any = BETLION_DEPOSIT_CHANNELS) => {
  return {
    type: actionTypes.deposit.BETLION_GET_CHANNELS,
    channelsType,
  };
};
/**
 * @deprecated
 * @param data
 */
export const betLionReceivedChannels = (data: any) => {
  return {
    type: actionTypes.deposit.BETLION_RECEIVED_CHANNELS,
    data,
  };
};
/**
 * @deprecated
 * @param paymentCode
 */
export const betLionReceivedEkwanza = (paymentCode: string) => {
  return {
    type: actionTypes.deposit.BETLION_RECEIVED_EKWANZA,
    paymentCode,
  };
};
/**
 * @deprecated
 * @param url
 * @param qrCode
 */
export const betLionReceivedPayPay = (url: string, qrCode: any) => {
  return {
    type: actionTypes.deposit.BETLION_RECEIVED_PAYPAY,
    url,
    qrCode,
  };
};
/**
 * @deprecated
 * @param data
 */
export const betLionReceivedPaychangu = (data: any) => {
  return {
    type: actionTypes.deposit.BETLION_RECEIVED_PAYCHANGU,
    ...data,
  };
};
/**
 * @deprecated
 */
export const betLionGetAlternativePhoneNumber = () => {
  return {
    type: actionTypes.deposit.BETLION_GET_ALTERNATIVE_PHONE_NUMBER,
  };
};
/**
 * @deprecated
 * @param alternativePhoneNumber
 */
export const betLionReceivedAlternativePhoneNumber = (alternativePhoneNumber: any) => {
  return {
    type: actionTypes.deposit.BETLION_RECEIVED_ALTERNATIVE_PHONE_NUMBER,
    alternativePhoneNumber,
  };
};
/**
 * @deprecated
 * @param amount
 */
export const getTax = (amount: number) => {
  return {
    type: actionTypes.deposit.GET_TAX,
    data: [
      {
        taxType: TAX_TYPE_DEPOSIT,
        totalAmount: amount * 100,
        key: 'deposit',
      },
    ],
  };
};
/**
 * @deprecated
 * @param data
 */
export const receivedTax = (data: any) => {
  return {
    type: actionTypes.deposit.RECEIVED_TAX,
    data: data,
  };
};